// Code generated by apiclient. DO NOT EDIT.

import type {
  AcceptInvitationRequest,
  AdminServerDetail,
  AuthResponse,
  ChangeEmailRequest,
  ChangeEmailResponse,
  CreateOrgInvitationRequest,
  CreateOrganizationRequest,
  CreatePageRequest,
  CreatePageResponse,
  CreateRecordRequest,
  CreateRecordResponse,
  CreateTableRequest,
  CreateTableUnderParentResponse,
  CreateViewRequest,
  CreateViewResponse,
  CreateWSInvitationRequest,
  CreateWorkspaceRequest,
  DeleteNodeAssetResponse,
  DeleteNodeResponse,
  DeleteNotificationResponse,
  DeletePageResponse,
  DeleteRecordResponse,
  DeleteTableResponse,
  DeleteViewResponse,
  ErrorResponse,
  GetNodeTitlesRequest,
  GetNodeTitlesResponse,
  GetNodeVersionResponse,
  GetPageResponse,
  GetRecordResponse,
  GetTableSchemaResponse,
  GitHubAppAvailableResponse,
  GitRemoteResponse,
  GitSyncStatusResponse,
  HealthResponse,
  ListGitHubAppInstallationsResponse,
  ListGitHubAppReposRequest,
  ListGitHubAppReposResponse,
  ListNodeAssetsResponse,
  ListNodeChildrenResponse,
  ListNodeVersionsRequest,
  ListNodeVersionsResponse,
  ListNotificationsRequest,
  ListNotificationsResponse,
  ListOrgInvitationsResponse,
  ListRecordsRequest,
  ListRecordsResponse,
  ListSessionsResponse,
  ListUsersResponse,
  ListWSInvitationsResponse,
  ListWorkspaceMembersResponse,
  LoginRequest,
  LogoutResponse,
  MarkAllNotificationsReadResponse,
  MarkNotificationReadResponse,
  MoveNodeRequest,
  MoveNodeResponse,
  NodeResponse,
  NotificationPrefsDTO,
  NotionImportCancelResponse,
  NotionImportRequest,
  NotionImportResponse,
  NotionImportStatusResponse,
  OkResponse,
  OrgInvitationResponse,
  OrganizationResponse,
  ProvidersResponse,
  PushSubscribeRequest,
  PushSubscribeResponse,
  PushUnsubscribeRequest,
  PushUnsubscribeResponse,
  RegisterRequest,
  RemoveOrgMemberRequest,
  ResolveUsersRequest,
  ResolveUsersResponse,
  RevokeAllSessionsResponse,
  RevokeSessionRequest,
  RevokeSessionResponse,
  SearchRequest,
  SearchResponse,
  SendVerificationEmailResponse,
  ServerConfigResponse,
  SetPasswordRequest,
  SetupGitHubAppRemoteRequest,
  SwitchWorkspaceRequest,
  SwitchWorkspaceResponse,
  UnreadCountResponse,
  UpdateGitRemoteRequest,
  UpdateNotificationPrefsRequest,
  UpdateOrgMemberRoleRequest,
  UpdateOrgPreferencesRequest,
  UpdateOrganizationRequest,
  UpdatePageFrontmatterRequest,
  UpdatePageFrontmatterResponse,
  UpdatePageRequest,
  UpdatePageResponse,
  UpdateRecordRequest,
  UpdateRecordResponse,
  UpdateServerConfigRequest,
  UpdateServerConfigResponse,
  UpdateTableRequest,
  UpdateTableResponse,
  UpdateUserSettingsRequest,
  UpdateViewRequest,
  UpdateViewResponse,
  UpdateWSMemberRoleRequest,
  UpdateWSMembershipSettingsRequest,
  UpdateWorkspaceRequest,
  UserResponse,
  VAPIDKeyResponse,
  WSInvitationResponse,
  WSMembershipResponse,
  WorkspaceResponse,
} from './types.gen';

/** Fetch function type - implement to add auth headers */
export type FetchFn = (url: string, init?: RequestInit) => Promise<Response>;

/** API error with parsed error response */
export class APIError extends Error {
  constructor(
    public status: number,
    public response: ErrorResponse
  ) {
    super(response.error.message);
    this.name = 'APIError';
  }
}

async function get<T>(fetchFn: FetchFn, url: string): Promise<T> {
  const res = await fetchFn(url);
  if (!res.ok) {
    const error = (await res.json()) as ErrorResponse;
    throw new APIError(res.status, error);
  }
  return res.json() as Promise<T>;
}

async function post<T>(fetchFn: FetchFn, url: string, body?: object): Promise<T> {
  const init: RequestInit = { method: 'POST' };
  if (body) {
    init.headers = { 'Content-Type': 'application/json' };
    init.body = JSON.stringify(body);
  }
  const res = await fetchFn(url, init);
  if (!res.ok) {
    const error = (await res.json()) as ErrorResponse;
    throw new APIError(res.status, error);
  }
  return res.json() as Promise<T>;
}

/** Creates a typed API client */
export function createAPIClient(fetchFn: FetchFn) {
  return {
    admin: {
      getServerDetail: () => get<AdminServerDetail>(fetchFn, `/api/v1/admin/server`),
    },
    auth: {
      email: {
        changeEmail: (options: ChangeEmailRequest) => post<ChangeEmailResponse>(fetchFn, `/api/v1/auth/email`, options),
        sendVerificationEmail: () => post<SendVerificationEmailResponse>(fetchFn, `/api/v1/auth/email/send-verification`),
      },
      invitations: {
        acceptOrgInvitation: (options: AcceptInvitationRequest) => post<AuthResponse>(fetchFn, `/api/v1/auth/invitations/org/accept`, options),
        acceptWSInvitation: (options: AcceptInvitationRequest) => post<AuthResponse>(fetchFn, `/api/v1/auth/invitations/ws/accept`, options),
      },
      sessions: {
        listSessions: () => get<ListSessionsResponse>(fetchFn, `/api/v1/auth/sessions`),
        revokeAllSessions: () => post<RevokeAllSessionsResponse>(fetchFn, `/api/v1/auth/sessions/revoke-all`),
        revokeSession: (options: RevokeSessionRequest) => post<RevokeSessionResponse>(fetchFn, `/api/v1/auth/sessions/revoke`, options),
      },
      getMe: () => get<UserResponse>(fetchFn, `/api/v1/auth/me`),
      listProviders: () => get<ProvidersResponse>(fetchFn, `/api/v1/auth/providers`),
      login: (options: LoginRequest) => post<AuthResponse>(fetchFn, `/api/v1/auth/login`, options),
      logout: () => post<LogoutResponse>(fetchFn, `/api/v1/auth/logout`),
      register: (options: RegisterRequest) => post<AuthResponse>(fetchFn, `/api/v1/auth/register`, options),
      setPassword: (options: SetPasswordRequest) => post<OkResponse>(fetchFn, `/api/v1/auth/password`, options),
      switchWorkspace: (options: SwitchWorkspaceRequest) => post<SwitchWorkspaceResponse>(fetchFn, `/api/v1/auth/switch-workspace`, options),
      updateUserSettings: (options: UpdateUserSettingsRequest) => post<UserResponse>(fetchFn, `/api/v1/auth/settings`, options),
    },
    githubApp: {
      isGitHubAppAvailable: () => get<GitHubAppAvailableResponse>(fetchFn, `/api/v1/github-app/available`),
      listGitHubAppInstallations: () => get<ListGitHubAppInstallationsResponse>(fetchFn, `/api/v1/github-app/installations`),
      listGitHubAppRepos: (options: ListGitHubAppReposRequest) => post<ListGitHubAppReposResponse>(fetchFn, `/api/v1/github-app/repos`, options),
    },
    notifications: {
      preferences: {
        getNotificationPrefs: () => get<NotificationPrefsDTO>(fetchFn, `/api/v1/notifications/preferences`),
        updateNotificationPrefs: (options: UpdateNotificationPrefsRequest) => post<NotificationPrefsDTO>(fetchFn, `/api/v1/notifications/preferences`, options),
      },
      readAll: {
        markAllNotificationsRead: () => post<MarkAllNotificationsReadResponse>(fetchFn, `/api/v1/notifications/read-all`),
      },
      vapidKey: {
        getVAPIDPublicKey: () => get<VAPIDKeyResponse>(fetchFn, `/api/v1/notifications/vapid-key`),
      },
      deleteNotification: (id: string) => post<DeleteNotificationResponse>(fetchFn, `/api/v1/notifications/${id}/delete`),
      getUnreadCount: () => get<UnreadCountResponse>(fetchFn, `/api/v1/notifications/unread-count`),
      async listNotifications(options: ListNotificationsRequest): Promise<ListNotificationsResponse> {
        const params = new URLSearchParams();
        if (options.Limit) params.set('limit', String(options.Limit));
        if (options.Offset) params.set('offset', String(options.Offset));
        if (options.UnreadOnly) params.set('unread_only', String(options.UnreadOnly));
        const url = `/api/v1/notifications` + (params.toString() ? `?${params}` : '');
        return get<ListNotificationsResponse>(fetchFn, url);
      },
      markNotificationRead: (id: string) => post<MarkNotificationReadResponse>(fetchFn, `/api/v1/notifications/${id}/read`),
      subscribePush: (options: PushSubscribeRequest) => post<PushSubscribeResponse>(fetchFn, `/api/v1/notifications/subscribe`, options),
      unsubscribePush: (options: PushUnsubscribeRequest) => post<PushUnsubscribeResponse>(fetchFn, `/api/v1/notifications/unsubscribe`, options),
    },
    organizations: {
      createOrganization: (options: CreateOrganizationRequest) => post<OrganizationResponse>(fetchFn, `/api/v1/organizations`, options),
    },
    server: {
      getConfig: () => get<ServerConfigResponse>(fetchFn, `/api/v1/server/config`),
      updateConfig: (options: UpdateServerConfigRequest) => post<UpdateServerConfigResponse>(fetchFn, `/api/v1/server/config`, options),
    },
    getHealth: () => get<HealthResponse>(fetchFn, `/api/v1/health`),

    /** Returns an org-scoped API client */
    org(orgID: string) {
      return {
        invitations: {
          createOrgInvitation: (options: CreateOrgInvitationRequest) => post<OrgInvitationResponse>(fetchFn, `/api/v1/organizations/${orgID}/invitations`, options),
          listOrgInvitations: () => get<ListOrgInvitationsResponse>(fetchFn, `/api/v1/organizations/${orgID}/invitations`),
        },
        notion: {
          getStatus: (importWsID: string) => get<NotionImportStatusResponse>(fetchFn, `/api/v1/organizations/${orgID}/notion/import/${importWsID}/status`),
          startImport: (options: NotionImportRequest) => post<NotionImportResponse>(fetchFn, `/api/v1/organizations/${orgID}/notion/import`, options),
        },
        organizations: {
          getOrganization: () => get<OrganizationResponse>(fetchFn, `/api/v1/organizations/${orgID}`),
          updateOrganization: (options: UpdateOrganizationRequest) => post<OrganizationResponse>(fetchFn, `/api/v1/organizations/${orgID}`, options),
        },
        settings: {
          updateOrgPreferences: (options: UpdateOrgPreferencesRequest) => post<OrganizationResponse>(fetchFn, `/api/v1/organizations/${orgID}/settings`, options),
        },
        users: {
          listUsers: () => get<ListUsersResponse>(fetchFn, `/api/v1/organizations/${orgID}/users`),
          removeOrgMember: (options: RemoveOrgMemberRequest) => post<OkResponse>(fetchFn, `/api/v1/organizations/${orgID}/users/remove`, options),
          updateOrgMemberRole: (options: UpdateOrgMemberRoleRequest) => post<UserResponse>(fetchFn, `/api/v1/organizations/${orgID}/users/role`, options),
        },
        workspaces: {
          createWorkspace: (options: CreateWorkspaceRequest) => post<WorkspaceResponse>(fetchFn, `/api/v1/organizations/${orgID}/workspaces`, options),
        },
      };
    },

    /** Returns a workspace-scoped API client */
    ws(wsID: string) {
      return {
        invitations: {
          createWSInvitation: (options: CreateWSInvitationRequest) => post<WSInvitationResponse>(fetchFn, `/api/v1/workspaces/${wsID}/invitations`, options),
          listWSInvitations: () => get<ListWSInvitationsResponse>(fetchFn, `/api/v1/workspaces/${wsID}/invitations`),
        },
        nodes: {
          assets: {
            deleteNodeAsset: (id: string, name: string) => post<DeleteNodeAssetResponse>(fetchFn, `/api/v1/workspaces/${wsID}/nodes/${id}/assets/${name}/delete`),
            listNodeAssets: (id: string) => get<ListNodeAssetsResponse>(fetchFn, `/api/v1/workspaces/${wsID}/nodes/${id}/assets`),
          },
          history: {
            getNodeVersion: (id: string, hash: string) => get<GetNodeVersionResponse>(fetchFn, `/api/v1/workspaces/${wsID}/nodes/${id}/history/${hash}`),
            async listNodeVersions(id: string, options: ListNodeVersionsRequest): Promise<ListNodeVersionsResponse> {
              const params = new URLSearchParams();
              if (options.Limit) params.set('limit', String(options.Limit));
              const url = `/api/v1/workspaces/${wsID}/nodes/${id}/history` + (params.toString() ? `?${params}` : '');
              return get<ListNodeVersionsResponse>(fetchFn, url);
            },
          },
          page: {
            createPage: (id: string, options: CreatePageRequest) => post<CreatePageResponse>(fetchFn, `/api/v1/workspaces/${wsID}/nodes/${id}/page/create`, options),
            deletePage: (id: string) => post<DeletePageResponse>(fetchFn, `/api/v1/workspaces/${wsID}/nodes/${id}/page/delete`),
            getPage: (id: string) => get<GetPageResponse>(fetchFn, `/api/v1/workspaces/${wsID}/nodes/${id}/page`),
            updatePage: (id: string, options: UpdatePageRequest) => post<UpdatePageResponse>(fetchFn, `/api/v1/workspaces/${wsID}/nodes/${id}/page`, options),
            updatePageFrontmatter: (id: string, options: UpdatePageFrontmatterRequest) => post<UpdatePageFrontmatterResponse>(fetchFn, `/api/v1/workspaces/${wsID}/nodes/${id}/page/frontmatter`, options),
          },
          table: {
            records: {
              createRecord: (id: string, options: CreateRecordRequest) => post<CreateRecordResponse>(fetchFn, `/api/v1/workspaces/${wsID}/nodes/${id}/table/records/create`, options),
              deleteRecord: (id: string, rid: string) => post<DeleteRecordResponse>(fetchFn, `/api/v1/workspaces/${wsID}/nodes/${id}/table/records/${rid}/delete`),
              getRecord: (id: string, rid: string) => get<GetRecordResponse>(fetchFn, `/api/v1/workspaces/${wsID}/nodes/${id}/table/records/${rid}`),
              async listRecords(id: string, options: ListRecordsRequest): Promise<ListRecordsResponse> {
                const params = new URLSearchParams();
                if (options.ViewID) params.set('view_id', options.ViewID);
                if (options.Filters) params.set('filters', options.Filters);
                if (options.Sorts) params.set('sorts', options.Sorts);
                if (options.Offset) params.set('offset', String(options.Offset));
                if (options.Limit) params.set('limit', String(options.Limit));
                const url = `/api/v1/workspaces/${wsID}/nodes/${id}/table/records` + (params.toString() ? `?${params}` : '');
                return get<ListRecordsResponse>(fetchFn, url);
              },
              updateRecord: (id: string, rid: string, options: UpdateRecordRequest) => post<UpdateRecordResponse>(fetchFn, `/api/v1/workspaces/${wsID}/nodes/${id}/table/records/${rid}`, options),
            },
            createTable: (id: string, options: CreateTableRequest) => post<CreateTableUnderParentResponse>(fetchFn, `/api/v1/workspaces/${wsID}/nodes/${id}/table/create`, options),
            deleteTable: (id: string) => post<DeleteTableResponse>(fetchFn, `/api/v1/workspaces/${wsID}/nodes/${id}/table/delete`),
            getTable: (id: string) => get<GetTableSchemaResponse>(fetchFn, `/api/v1/workspaces/${wsID}/nodes/${id}/table`),
            updateTable: (id: string, options: UpdateTableRequest) => post<UpdateTableResponse>(fetchFn, `/api/v1/workspaces/${wsID}/nodes/${id}/table`, options),
          },
          views: {
            createView: (id: string, options: CreateViewRequest) => post<CreateViewResponse>(fetchFn, `/api/v1/workspaces/${wsID}/nodes/${id}/views/create`, options),
            deleteView: (id: string, viewID: string) => post<DeleteViewResponse>(fetchFn, `/api/v1/workspaces/${wsID}/nodes/${id}/views/${viewID}/delete`),
            updateView: (id: string, viewID: string, options: UpdateViewRequest) => post<UpdateViewResponse>(fetchFn, `/api/v1/workspaces/${wsID}/nodes/${id}/views/${viewID}`, options),
          },
          deleteNode: (id: string) => post<DeleteNodeResponse>(fetchFn, `/api/v1/workspaces/${wsID}/nodes/${id}/delete`),
          getNode: (id: string) => get<NodeResponse>(fetchFn, `/api/v1/workspaces/${wsID}/nodes/${id}`),
          async getNodeTitles(options: GetNodeTitlesRequest): Promise<GetNodeTitlesResponse> {
            const params = new URLSearchParams();
            if (options.IDs) params.set('ids', options.IDs);
            const url = `/api/v1/workspaces/${wsID}/nodes/titles` + (params.toString() ? `?${params}` : '');
            return get<GetNodeTitlesResponse>(fetchFn, url);
          },
          listNodeChildren: (id: string) => get<ListNodeChildrenResponse>(fetchFn, `/api/v1/workspaces/${wsID}/nodes/${id}/children`),
          moveNode: (id: string, options: MoveNodeRequest) => post<MoveNodeResponse>(fetchFn, `/api/v1/workspaces/${wsID}/nodes/${id}/move`, options),
        },
        notion: {
          cancelImport: () => post<NotionImportCancelResponse>(fetchFn, `/api/v1/workspaces/${wsID}/notion/import/cancel`),
        },
        settings: {
          git: {
            deleteGitRemote: () => post<OkResponse>(fetchFn, `/api/v1/workspaces/${wsID}/settings/git/delete`),
            getGitRemote: () => get<GitRemoteResponse>(fetchFn, `/api/v1/workspaces/${wsID}/settings/git`),
            getSyncStatus: () => get<GitSyncStatusResponse>(fetchFn, `/api/v1/workspaces/${wsID}/settings/git/status`),
            pullGit: () => post<OkResponse>(fetchFn, `/api/v1/workspaces/${wsID}/settings/git/pull`),
            pushGit: () => post<OkResponse>(fetchFn, `/api/v1/workspaces/${wsID}/settings/git/push`),
            setupGitHubAppRemote: (options: SetupGitHubAppRemoteRequest) => post<GitRemoteResponse>(fetchFn, `/api/v1/workspaces/${wsID}/settings/git/github-app`, options),
            updateGitRemote: (options: UpdateGitRemoteRequest) => post<GitRemoteResponse>(fetchFn, `/api/v1/workspaces/${wsID}/settings/git`, options),
          },
          updateWSMembershipSettings: (options: UpdateWSMembershipSettingsRequest) => post<WSMembershipResponse>(fetchFn, `/api/v1/workspaces/${wsID}/settings/membership`, options),
        },
        users: {
          resolveUsers: (options: ResolveUsersRequest) => post<ResolveUsersResponse>(fetchFn, `/api/v1/workspaces/${wsID}/users/resolve`, options),
          updateWSMemberRole: (options: UpdateWSMemberRoleRequest) => post<UserResponse>(fetchFn, `/api/v1/workspaces/${wsID}/users/role`, options),
        },
        workspaces: {
          getWorkspace: () => get<WorkspaceResponse>(fetchFn, `/api/v1/workspaces/${wsID}`),
          updateWorkspace: (options: UpdateWorkspaceRequest) => post<WorkspaceResponse>(fetchFn, `/api/v1/workspaces/${wsID}`, options),
        },
        listWorkspaceMembers: () => get<ListWorkspaceMembersResponse>(fetchFn, `/api/v1/workspaces/${wsID}/members`),
        search: (options: SearchRequest) => post<SearchResponse>(fetchFn, `/api/v1/workspaces/${wsID}/search`, options),
      };
    },
  };
}

export type APIClient = ReturnType<typeof createAPIClient>;
export type OrgAPIClient = ReturnType<APIClient['org']>;
export type WSAPIClient = ReturnType<APIClient['ws']>;
